import '@/styles/app'
import 'reflect-metadata'
import '@/polyfills/requestIdleCallback'
import '@/polyfills/promiseWithResolvers'
import '@/polyfills/localStoragePolyfill'
import 'virtual:mdi-icons-round.css'
import 'virtual:tmi-icons.css'
import App from '@/components/views/App.vue'
import RouterMiddleware from '@/core/middlewares/routerMiddleware'
import type VueService from '@/services/vueService'
import LoggerMiddleware from '@/core/middlewares/loggerMiddleware'
import GlobalErrorHandlerMiddleware from '@/core/middlewares/errorHandlerMiddleware'
import { buildContainer, get } from '@/core/container/container'
import { getServicesMiddlewares, processMiddlewares } from '@/core/middlewares/middleware'
import servicesWeb from '@/config/servicesWeb'
import {
  backgroundLoadAndBindAllDeps,
  checkDeps,
  loadAndBindDeferredDeps,
  loadAndBindStartupDeps,
  printServicesInModules,
} from '@/core/container/deps'
import { initRetryingDynamicImport } from '@textmagic/vite-plugin-retrying-dynamic-import/runtime'
import type { TelemetryService } from '@/services/telemetry/telemetryService'
import { lazyLoadEmojiData } from '@/utils/emoji/emojiHelpers'
import TranslateMiddleware from '@/core/middlewares/translateMiddleware'
import { TmAppLoadedEvent } from '@/core/events/TmAppLoadedEvent'
import { getEventBusService, getLoggerService } from '@/core/container/ioc'
import { vueAppId } from '@/types'

initRetryingDynamicImport({
  checkOnlineUrl: import.meta.env.VUE_APP_APP_URL,
  onError: (error) => getLoggerService().error('globalException', error.message, `AsyncChunk::${error.name}`),
})

const modules = buildContainer(servicesWeb, checkDeps)

import('@/initApp/getPosthog')
if (import.meta.env.VUE_APP_SERVICES_IN_MODULES_WARNING === 'true') {
  printServicesInModules()
}

processMiddlewares([
  new GlobalErrorHandlerMiddleware(),
  new RouterMiddleware(modules),
  new LoggerMiddleware(),
  new TranslateMiddleware(),
  ...getServicesMiddlewares(),
])

get<VueService>('VueService').create(vueAppId, App)

lazyLoadEmojiData()

loadAndBindStartupDeps()

getEventBusService().subscribe(TmAppLoadedEvent, () => {
  loadAndBindDeferredDeps()

  if (import.meta.env.VUE_APP_DISABLE_BACKGROUND_MODULE_LOADING !== 'true') {
    backgroundLoadAndBindAllDeps()
  }
})

const telemetryService = get<TelemetryService>('TelemetryService')
telemetryService.init()
